export default {"src":"/_next/static/image/src/atoms/Checkbox/Checkmark.34f8353d81092f75fc4f64042c964ab5.svg","height":14,"width":15};